import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { useEffect, useState } from "react";
import configUrls from "../../../config/configUrls";
import { useFavoritarProcessoMutation } from "../processoApiSlice";
import IconButton from '@mui/material/IconButton';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import StarIcon from '@mui/icons-material/Star';
import { useNavigate } from 'react-router-dom'; // Importação para navegação
import { useSnackbar } from "notistack";
import errorFormat from "../../../utils/errorFormat";
import Star from "@mui/icons-material/Star";

export const ButtonPressProcessoFavoritar = () => {

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate(); // Hook para navegação

  const [createProcesso, status] = useFavoritarProcessoMutation();


  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
  const [_, setRender] = useState<number>(0);


  /*
  // Efeito para verificar se o processo foi selecionado
  useEffect(() => {
    if (!processoSelecionado) {
      alert("Nenhum processo foi previamente selecionado");
      navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
    }
  }, [processoSelecionado, navigate]);
  */

  // Função para tratar o clique no botão
  const handleButtonPress = async () => {
    if (processoSelecionado) {
      try {
        // Dispara a mutação para "dar ciência" ao processo selecionado
        await createProcesso({ id: processoSelecionado.id });
        //
      } catch (e) {
        console.error("Erro ao favoritar ao processo:", e);
        enqueueSnackbar("Ocorreu um erro ao ao favoritar ao processo!", { variant: "error" });
      }
    } else {
      enqueueSnackbar("Nenhum processo foi previamente selecionado", { variant: "error" });
    }
  };

  useEffect(() => {
    if (status.isError) {
      //enqueueSnackbar("Ocorreu um erro ao dar ciência ao processo!", { variant: "error" })
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: "error" })
    }

    if (status.isSuccess) {
      enqueueSnackbar("Operação efetuada com sucesso com sucesso!", { variant: "success" });
      //navigate(-1);
      setRender(prev => prev + 1);
    }
  }, [status]);

  return (
    <IconButton
      color="secondary"
      size="large"
      onClick={handleButtonPress}
      disabled={status.isLoading}
    >
      {processoSelecionado?.favorito ? <Star /> : <StarOutlineOutlinedIcon />}


    </IconButton>
  );
};
